import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "timer",
  "use": "timer-usage",
  "viewBox": "0 0 12 11.999",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 12 11.999\" id=\"timer\"><path d=\"M46,40.074a6,6,0,1,1-12,0h.809a5.2,5.2,0,1,0,1.423-3.567H37.81v.809H34.972V34.48h.809v1.332A6,6,0,0,1,46,40.074Zm-6.162-3.162v3.811h3.324v-.811H40.648v-3Z\" transform=\"translate(-33.999 -34.076)\" fill=\"#6e6e6e\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol